'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './login.routes';

export class LoginComponent {
  constructor(authService, $window) {
    authService.destroySession();
    $window.location.href = '/api/oauth/authorize';
  }
}

LoginComponent.$inject = ['authService', '$window'];

export default angular.module('syncplicityLoginApp.login', [uiRouter])
  .config(routes)
  .component('login', {
    template: '',
    controller: LoginComponent,
    controllerAs: 'loginCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/login/login.component.js